import styles from "./service-cards.module.scss";
import Image from "next/image";
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";

type ServiceCardsProps = {
    section: {
        title: string;
        description: string;
        blocks: Array<{
            iconUrl: string;
            title: string;
            content: string[];
        }>;
    }
}

const ServiceCards = ({section}: ServiceCardsProps): JSX.Element => {
    return (
        <SharedAnimation render={(ref) => (
            <div ref={ref} className={`${styles.container} ${animations.scroll__animation}`}>
                <section className={`${styles.section}`}>
                    <h2 className={styles.section__title}>{section.title}</h2>
                    {section.description && (
                        <p className={styles.section__description}>{section.description}</p>
                    )}
                    <div className={styles.section__block}>
                        {section.blocks.map((block, index): JSX.Element => (
                            <div key={index} className={styles.section__block__item}>
                                <div className={styles.section__block__item__icon}>
                                    <Image
                                        src={block.iconUrl}
                                        width={32}
                                        height={32}
                                        alt={block.title}
                                        className={styles.icon__image}
                                    />
                                </div>
                                <h3 className={styles.section__block__item__title}>{block.title}</h3>
                                {block.content.map((text, idx) => (
                                    <p key={idx} className={styles.section__block__item__text}>{text}</p>
                                ))}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        )}/>
    );
};

export default ServiceCards;
